module.exports = __webpack_public_path__ + "img/classroom2.442c0bfe.svg";